/** A display-only shuffle: the same request seed reproduces SSR order in Vue. */
export function seededShuffle<T>(input: readonly T[], seed: number): T[] {
  const result = input.slice();
  let state = seed >>> 0;
  for (let i = result.length - 1; i > 0; i--) {
    state = (Math.imul(state, 1664525) + 1013904223) >>> 0;
    const j = Math.floor((state / 0x100000000) * (i + 1));
    [result[i], result[j]] = [result[j], result[i]];
  }
  return result;
}
